/** Scenarios presented to the user after completing a session */
export enum SessionCompletedScenario {
  JUST_COMPLETED = 'just-completed',
  NEXT_PENDING = 'next-pending',
  NEXT_COMPLETED = 'next-completed',
}